export default "__VITE_ASSET__VJ4ndvQ$__"